import { defineComponent as _defineComponent } from 'vue'
import BusStopList from "@/components/line/BusStopList.vue";
import { IBusStop } from "@/domain/entities/busStop";
import { IFavoriteLine } from "@/domain/entities/favoriteLine";
import { IBusLocation } from "@/domain/entities/lineInfo";
import {
  ITurnBusLastSeatCount,
  PROVIDE_KEY_BUS_LOCATIONS,
  PROVIDE_KEY_IS_BUS_RUNNING,
  PROVIDE_KEY_TURN_BUSES_REMAIN_SEAT_COUNT,
} from "@/types";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import {
  computed,
  ComputedRef,
  inject,
  onDeactivated,
  PropType,
  Ref,
  ref,
} from "vue";
import InlineSvg from "vue-inline-svg";
import LineTypeChip from "../shared/chip/LineTypeChip.vue";
import Tooltip from "../shared/Tooltip.vue";


const __default__ = {
  name: "MainCardShuttle",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  favoriteLine: {
    type: Object as PropType<IFavoriteLine>,
    required: true,
  },
},
  emits: ["onClickLineInfo", "onClickScheduleBtn", "updateBusLocation", "onClickBusStopLocation", "onClickBusImage"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const emitOnClickBusStopLocation = (busStop: IBusStop) => {
  closeBusPlateNumbersTooltip();
  emit("onClickBusStopLocation", busStop);
};

const emitOnClickScheduleBtn = (busStop: IBusStop) => {
  closeBusPlateNumbersTooltip();
  emit("onClickScheduleBtn", busStop);
};

const emitOnClickBusImage = () => {
  if (!hasBusImage.value) return;
  closeBusPlateNumbersTooltip();
  emit("onClickBusImage");
};

/** 버스 운행중 여부 */
const isBusRunning = inject(PROVIDE_KEY_IS_BUS_RUNNING) as Ref<boolean>;

/** 버스들의 잔여좌석 리스트 */
const turnBusLastSeatCountList = inject(
  PROVIDE_KEY_TURN_BUSES_REMAIN_SEAT_COUNT
) as ComputedRef<ITurnBusLastSeatCount[]>;

const displayLastSeatCount = (allocUid: string) => {
  if (!isBusRunning.value) return "";

  if (
    turnBusLastSeatCountList.value &&
    turnBusLastSeatCountList.value.length === 0
  ) {
    return "";
  }

  const selectedBusRemainSeatCount = turnBusLastSeatCountList.value.find(
    (seatCount) => seatCount.allocUid === allocUid
  );

  if (
    !selectedBusRemainSeatCount ||
    selectedBusRemainSeatCount.boardingCount === -1
  ) {
    return "";
  }

  return `(탑승${selectedBusRemainSeatCount.boardingCount})`;
};

const refreshButton = ref<HTMLElement>();
const updateBusLocation = () => {
  refreshButton.value?.classList.add("rotate");
  setTimeout(() => {
    refreshButton.value?.classList.remove("rotate");
  }, 1000);
  emit("updateBusLocation");
};

const header = ref<HTMLElement>();
const contentArea = ref<HTMLElement>();

const busLocations = inject(PROVIDE_KEY_BUS_LOCATIONS) as
  | Ref<IBusLocation[]>
  | undefined;

const currentBusLocations = computed(() =>
  busLocations?.value?.filter(
    (busLocation) => busLocation.lineTurnUid === props.favoriteLine.turnId
  )
);

// 차량 정보
const hasBusImage = computed(() =>
  props.favoriteLine.buses?.some((bus) => !!bus.busImages?.length)
);

const hasBusPlateNumber = computed(() =>
  props.favoriteLine.buses?.some((bus) => !!bus.carNo)
);

const busPlateNumbers = computed(() =>
  props.favoriteLine.buses?.filter((bus) => bus.carNo).map((bus) => bus.carNo)
);

const busPlateNumberText = computed(() => {
  if (props.favoriteLine.boardedCarNo) {
    return props.favoriteLine.boardedCarNo;
  }

  const busCount = props.favoriteLine.buses?.length ?? 0;
  const bus = props.favoriteLine.buses?.find((bus) => !!bus.carNo?.length);

  if (!bus) {
    return ` - ${busCount > 1 ? `외 ${busCount - 1}` : ""}`;
  }

  const selectedBusLastSeatCount = turnBusLastSeatCountList.value.find(
    (seatCount) => seatCount.allocUid === bus?.allocUid
  );

  const singleBusText = `${bus.carNo}`;
  const multipleBusText = `${bus.carNo} 외 ${busCount - 1}`;

  const isSingleBus = busCount === 1;
  const busPlateText = isSingleBus ? singleBusText : multipleBusText;

  if (!selectedBusLastSeatCount || !isBusRunning.value) {
    return busPlateText;
  }

  const { boardingCount } = selectedBusLastSeatCount;

  const boardingCountText =
    boardingCount === -1 ? "" : `(탑승${boardingCount})`;

  return isSingleBus ? `${busPlateText}${boardingCountText}` : busPlateText;
});

const tooltipTargetElement = ref<HTMLElement>();
const shouldShowBusPlateNumbers = ref(false);
const toggleShowBusPlateNumbers = (event: Event) => {
  if ((busPlateNumbers.value?.length ?? 0) <= 1) return;
  shouldShowBusPlateNumbers.value = !shouldShowBusPlateNumbers.value;
  if (shouldShowBusPlateNumbers.value) {
    tooltipTargetElement.value = event.target as HTMLElement;
  }
};
const closeBusPlateNumbersTooltip = () => {
  shouldShowBusPlateNumbers.value = false;
};

onDeactivated(() => {
  closeBusPlateNumbersTooltip();
});

__expose({ closeBusPlateNumbersTooltip });

const __returned__ = { props, emit, emitOnClickBusStopLocation, emitOnClickScheduleBtn, emitOnClickBusImage, isBusRunning, turnBusLastSeatCountList, displayLastSeatCount, refreshButton, updateBusLocation, header, contentArea, busLocations, currentBusLocations, hasBusImage, hasBusPlateNumber, busPlateNumbers, busPlateNumberText, tooltipTargetElement, shouldShowBusPlateNumbers, toggleShowBusPlateNumbers, closeBusPlateNumbersTooltip, BusStopList, get useGetLineRouteName() { return useGetLineRouteName }, get InlineSvg() { return InlineSvg }, LineTypeChip, Tooltip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})